import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AppLoader from '../../components/appLoader/AppLoader';
import * as ROUTES from '../../constants/routes';
import { sendGridEmail } from '../../firebase/api/mail';
import { getPostByUid, markPostAsUnread, updatePost } from '../../firebase/api/post';
import { createReview } from '../../firebase/api/review';
import { getUserByUid } from '../../firebase/api/users';
import { getFirstAnswerForInvite } from '../../templates';

import './InvitationResult.css'

const responseTypes = {
    accept: 'accept',
    decline: 'decline'
}

const InvitationResult = ({ isAuth }) => {

    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const params = new URL(window.location).searchParams

    const postUid = params.get('postUid')
    const responseSenderUid = params.get('senderUid')
    const responseType = params.get('res')

    const setResponse = useCallback(
        async() => {
            let postOwnerData, responseSenderData, rawPost;

            await getPostByUid(postUid)
                .then(response => {
                    rawPost = response
                    getUserByUid(response.publisherUid)
                        .then(postOwner => postOwnerData = postOwner)
                })
                .catch(error => alert(error))
            await getUserByUid(responseSenderUid)
                .then(responseSender => responseSenderData = responseSender)
                .catch(error => alert(error))
            if (
                rawPost &&
                postOwnerData &&
                responseSenderData &&
                responseTypes.hasOwnProperty(responseType) &&
                !rawPost.responseEmails.filter(item => item.email === responseSenderData.email).length // in case if user already answered in SideKick
            ) {
                const reviewDto = {
                    postOwnerUid: postOwnerData.uid,
                    postUid: postUid,
                    publisherUid: responseSenderUid,
                    publisherFullName: responseSenderData.firstName + ' ' + responseSenderData.lastName,
                    publisherFirstName: responseSenderData.firstName,
                    publisherLastName: responseSenderData. lastName,
                    publisherPosition: responseSenderData?.position || '',
                    response: responseType,
                    publisherEmail: responseSenderData.email,
                };

                const review = await createReview(reviewDto);

                if (!rawPost.viewed.filter(item => item.email === responseSenderData.email).length) {
                    rawPost.viewed.push({
                        name: responseSenderData.firstName + ' ' + responseSenderData.lastName,
                        email: responseSenderData.email,
                        position: responseSenderData?.position || '',
                        uid: responseSenderData.uid
                    })
                }

                rawPost.unviewed = rawPost.unviewed.filter(item => item.email !== responseSenderData.email)
                rawPost.unreviewed = rawPost.unreviewed.filter(item => item.email !== responseSenderData.email)
                rawPost.reviewIds.push(review.id);
                rawPost.responseEmails.push({
                    email: responseSenderData.email,
                    response: responseType
                })

                await updatePost(rawPost)
                    .then(() => {
                        markPostAsUnread(postUid);

                        if(rawPost.responseEmails.length === 1) { // when first freelancer answer to invite
                            const recipientInfo = {
                                email: postOwnerData.email,
                                uid: postOwnerData.uid,
                                firstName: postOwnerData.firstName,
                                lastName: postOwnerData.lastName,
                            }
                            sendGridEmail(
                                getFirstAnswerForInvite(responseSenderData.email, recipientInfo, `${window.location.origin}/posts/${postUid}`, rawPost.title)
                            )
                        }
                    });
            }
            setLoading(false)
        },
        [
            loading,
            postUid,
            responseSenderUid,
            responseType
        ]
    )

    useEffect(() => {
        if (isAuth) {
            navigate(`${ROUTES.POSTS}/${postUid}`)
        } else if (responseTypes.hasOwnProperty(responseType) && postUid && responseSenderUid) {
            setResponse()
        } else {
            navigate(ROUTES.LANDING)
        }
    }, [])

    const handleClick = () => {
        window.close();
    }

    return (
        <div className="invitation-result-wrap">
            {
                !loading
                ? <>
                    <span>Thank you, we&apos;ve recorded your answer.</span>
                    <button onClick={handleClick}>Go back</button>
                </>
                : <AppLoader />
            }
        </div>
    )
}

export default InvitationResult